// extracted by mini-css-extract-plugin
export default {"login":"SsoRegistrationSpPage_login_C0r3W","title":"SsoRegistrationSpPage_title_obikB","next_button_wrap":"SsoRegistrationSpPage_next_button_wrap_BPbys"};